window.addEventListener('DOMContentLoaded', () => {
    footerCollapsible();
});

window.addEventListener('resize', () => {
    footerCollapsible();
});

const footerCollapsible = () => {
    if (window.matchMedia('(min-width: 750px)').matches) {
        return;
    }

    const handleCollapse = (heading) => {
        if (heading.classList.contains('block-collapsed')) {
            heading.classList.remove('block-collapsed')
            heading.setAttribute('aria-expanded', 'true')
        } else {
            heading.classList.add('block-collapsed')
            heading.setAttribute('aria-expanded', 'false')
        }
    }

    document.querySelectorAll('.footer-block__heading').forEach((heading, index) => {
        heading.nextElementSibling.setAttribute('id', `footer-block-index-${index}`)
        heading.setAttribute('aria-controls', `footer-block-index-${index}`)

        heading.addEventListener('click', () => { handleCollapse(heading) })
        heading.addEventListener('keypress', () => { handleCollapse(heading) })
    })
}
